export default __webpack_public_path__ + "static/media/user-emma.54a9a3ed.png";